import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InfoRodada } from '../../../model/interface/info-rodada';

@Injectable({
  providedIn: 'root'
})
export class DetalhesService {

  private infoRodada = new BehaviorSubject<InfoRodada>(null);
  infoRodada$ = this.infoRodada.asObservable();

  constructor() { }

  setInfoRodada(infoRodada: InfoRodada): void {
    this.infoRodada.next(infoRodada);
  }

}
